import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Document\GetDocumentVariableByModelController::__invoke
* @see app/Http/Controllers/Document/GetDocumentVariableByModelController.php
* @route '/api/get-variable'
*/
const GetDocumentVariableByModelController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetDocumentVariableByModelController.url(options),
    method: 'post',
})

GetDocumentVariableByModelController.definition = {
    methods: ["post"],
    url: '/api/get-variable',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Document\GetDocumentVariableByModelController::__invoke
* @see app/Http/Controllers/Document/GetDocumentVariableByModelController.php
* @route '/api/get-variable'
*/
GetDocumentVariableByModelController.url = (options?: RouteQueryOptions) => {
    return GetDocumentVariableByModelController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Document\GetDocumentVariableByModelController::__invoke
* @see app/Http/Controllers/Document/GetDocumentVariableByModelController.php
* @route '/api/get-variable'
*/
GetDocumentVariableByModelController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: GetDocumentVariableByModelController.url(options),
    method: 'post',
})

export default GetDocumentVariableByModelController